/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setEditMode, updatePageDetails, changePage } from '@insticator/insticator-ui';
import { editReport } from 'state/actions/reportsState/reports_status';
// component
import PreviewPage from 'pages/dashboard/reports/preview/preview';


/* ========== ~~~~~~~~~~ REPORT PREVIEW : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ reportsState, appStatus }) => ({
    isDataReceived: reportsState.reportsStatus.isDataReceived,
    clientReports: reportsState.reportsStatus.clientEmbeds,
    previewData: reportsState.selectedReportStatus.previewReportData,
    accountUUID: reportsState.selectedReportStatus.selectedReportData.accountUUID,
    dateRange: reportsState.selectedReportStatus.selectedReportData.dateRange,
    isReportSaved: reportsState.selectedReportStatus.status.isReportSaved,
    customDateRange: reportsState.selectedReportStatus.selectedReportData.customDateRange,
    processing: reportsState.selectedReportStatus.status.processing,
    currentPage: appStatus.currentPage
});

// map actions
const mapDispatchToProps = dispatch => ({
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    },
    setEditMode: editState => dispatch(setEditMode(editState)),
    editReport: reportUUID => dispatch(editReport(reportUUID))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PreviewPage);
